<template>
  <div
    class="tw-mr-auto tw-inline-flex tw-h-10 tw-items-baseline tw-justify-start"
  >
    <span class="tw-text-sm tw-text-dorian-gray-500">
      <span>
        {{ `${start} - ${end}` }}
      </span>
      <span>
        {{ ` ${placeholder} ` }}
      </span>
      <span>
        {{ formattedTotal }}
      </span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { toRefs, computed } from "vue";

const props = defineProps<{
  start: number;
  end: number;
  total: number;
  placeholder: string;
}>();

const { start, end, total, placeholder } = toRefs(props);

const formattedTotal = computed(() => total.value.toLocaleString("en-US"));
</script>
